import React from 'react';
import {
  Storage,
  AssignmentOutlined,
  GridViewOutlined,
  FolderOpenOutlined,
  MailOutline
} from '@mui/icons-material';

const SOURCES = [
  { name: 'Policy admin', caption: 'its own system', Icon: Storage },
  { name: 'Claims system', caption: 'another, unconnected', Icon: AssignmentOutlined },
  { name: 'Bordereaux', caption: 'monthly files from every counterparty', Icon: GridViewOutlined },
  { name: 'Submissions', caption: 'slips, schedules, loss runs', Icon: FolderOpenOutlined },
  { name: 'Email & docs', caption: 'data with no system at all', Icon: MailOutline }
];

function SourceTile({ name, caption, Icon, showCaption }) {
  return (
    <div className="source-tile">
      <span className="source-tile__disc" aria-hidden="true">
        <Icon fontSize="inherit" />
      </span>
      <span className="source-tile__name">{name}</span>
      {showCaption && <span className="source-tile__caption">{caption}</span>}
    </div>
  );
}

/* Five disconnected sources, separated by an "x". Sits directly on the band. */
function BrokenSources() {
  return (
    <div className="sources sources--broken">
      <div className="sources__row">
        {SOURCES.map((source, index) => (
          <React.Fragment key={source.name}>
            {index > 0 && (
              <span className="sources__x" aria-hidden="true">
                &times;
              </span>
            )}
            <SourceTile {...source} showCaption />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

/* The same five sources feeding one Decode workspace: each tile drops a short
   stub onto a collector bar, and a single arrow carries everything down. */
function ConnectedSources() {
  return (
    <div className="diagram diagram--panel sources sources--connected">
      <div className="sources__row">
        {SOURCES.map((source) => (
          <SourceTile key={source.name} {...source} showCaption={false} />
        ))}
      </div>

      <div className="sources__bus" aria-hidden="true">
        <span className="sources__bar" />
        <svg className="sources__drop" width="12" height="44" viewBox="0 0 12 44" focusable="false">
          <path d="M6 0 V 34" fill="none" stroke="var(--blue)" strokeWidth="1.5" />
          <polygon points="1,33 11,33 6,43" fill="var(--blue)" />
        </svg>
      </div>

      <div className="decode-panel">
        <img src="/logo-512.png" alt="" className="decode-panel__mark" />
        <span className="decode-panel__word">DECODE</span>
        <span className="decode-panel__sub">Centralised data workspace</span>
        <span className="decode-panel__tags">Standardised &middot; Connected &middot; Auditable</span>
      </div>

      <p className="diagram__caption">One workspace, every record linked: policy to claim to payment.</p>
    </div>
  );
}

function SourcesDiagram({ mode = 'broken' }) {
  return mode === 'connected' ? <ConnectedSources /> : <BrokenSources />;
}

export default SourcesDiagram;
